import { render, staticRenderFns } from "./RelationshipsList.vue?vue&type=template&id=2e56ac0a&scoped=true&"
import script from "./RelationshipsList.vue?vue&type=script&lang=js&"
export * from "./RelationshipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56ac0a",
  null
  
)

export default component.exports